import { AtomError } from './error';
export function fatal(code, msg) {
  var err = new AtomError(code || 500, '[atom] ' + msg, '');
  err.modId = 'jsapi_error';
  console.error('[atom] ' + msg);
}
export function error(code, msg) {
  var err = new AtomError(code || 500, '[atom] ' + msg, '');
  err.modId = 'jsapi_error';
  console.error('[atom] ' + msg);
}
export function warn(code, msg) {
  console && console.warn('[invoke api] ', msg, ' `errCode: ' + code + '`');
}